import React, { useEffect, useContext, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { LoginForm } from '../components/auth/AuthForm';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import {
  PageWrapper,
  FormContainer,
  LogoContainer,
  Logo,
  BrandName,
  Title,
  CloseButton,
  SwitchText,
  SwitchLink
} from '../components/auth/AuthStyles';

const LoginPage = () => {
  const location = useLocation();
  const history = useHistory();
  const { isAuthenticated, login } = useContext(AuthContext);
  const queryParams = new URLSearchParams(location.search);
  const redirectTo = queryParams.get('redirectTo') || '/';
  const { language } = useLanguage();
  const t = translations[language].auth;

  useEffect(() => {
    if (isAuthenticated) {
      history.replace(redirectTo);
    }
  }, [isAuthenticated, history, redirectTo]);

  const handleLoginSuccess = () => {
    history.replace(redirectTo);
  };

  const handleClose = () => {
    history.push('/');
  };

  const handleLogin = async (credentials) => {
    try {
      await login(credentials.email, credentials.password);
      history.push('/');
    } catch (error) {
      console.error('Login error:', error);
      throw new Error(error.response?.data?.error || t.errors.default);
    }
  };

  return (
    <PageWrapper>
      <FormContainer>
        <CloseButton onClick={handleClose} title={t.close}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        
        <LogoContainer>
          <Logo src="/images/QQ-Icon.svg" alt="Quisqueya Quest" />
          <BrandName>Quisqueya Quest</BrandName>
        </LogoContainer>
        
        <Title>{t.welcomeBack}</Title>
        <LoginForm onSubmit={handleLogin} />
        <SwitchText>
          {t.noAccount.split('?')[0]}?{' '}
          <SwitchLink onClick={() => history.push('/signup')}>
            {t.signUp}
          </SwitchLink>
        </SwitchText>
      </FormContainer>
    </PageWrapper>
  );
};

export default LoginPage; 